import { render, staticRenderFns } from "./ReportInstructivoEmbarqueMaritimo.vue?vue&type=template&id=4f0ffd68&"
import script from "./ReportInstructivoEmbarqueMaritimo.vue?vue&type=script&lang=js&"
export * from "./ReportInstructivoEmbarqueMaritimo.vue?vue&type=script&lang=js&"
import style0 from "./ReportInstructivoEmbarqueMaritimo.vue?vue&type=style&index=0&id=4f0ffd68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports